import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
          {t('ctaTitle')}
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-500">
          {t('ctaSubtitle')}
        </p>
        <Link
          to="/category/all"
          className="whitespace-nowrap mt-8 inline-flex items-center gap-2 px-8 py-3 bg-primary-600 text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-primary-700 transition-all duration-300 cursor-pointer"
        >
          {t('ctaButton')}
          <i className="ri-arrow-right-line" />
        </Link>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {['明星塌房', '网红反差', '每日大赛', '独家爆料', '实时追踪', '吃瓜社区'].map((tag) => (
            <span
              key={tag}
              className="text-sm text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}